module.exports = __webpack_public_path__ + "img/image6.02260db0.png";